@if (!hasAssessments) {
<div class="no-assessments">
  <h3 class="no-assessments-text">No assessments have been added!</h3>
</div>
} @else {

<div class="main-container">
  <div class="time-bar">
    <p-menu [model]="menuItems"></p-menu>
  </div>
  <div class="assessment-info">
    <p-panel [header]="'Viewing Assessment from ' + selectedAssessmentDateString">
      <p-accordion>

        <app-expansion-panel title="General Appearance" value="0">
          <app-general-appearance-info [data]="generalAppearance" [patient]="patient" />
        </app-expansion-panel>

        <app-expansion-panel title="HEENT" value="1">
          <app-heent-info [data]="heent" />
        </app-expansion-panel>

        <app-expansion-panel title="Cardiovascular" value="2">
          <app-cardiovascular-info [data]="cardiovascular" />
        </app-expansion-panel>

        <app-expansion-panel title="Respiratory" value="3">
          <app-respiratory-info [data]="respiratory" />
        </app-expansion-panel>

        <app-expansion-panel title="Neurological" value="4">
          <app-neurological-info [data]="neurological" [patient]="patient" />
        </app-expansion-panel>

        <app-expansion-panel title="Musculoskeletal" value="5">
          <app-musculoskeletal-info [data]="musculoskeletal" />
        </app-expansion-panel>

        <app-expansion-panel title="Abdominal" value="6">
          <app-gastrointestinal-info [data]="gastrointestinal" />
        </app-expansion-panel>

        <app-expansion-panel title="Genitourinary" value="7">
          <app-genitourinary-info [data]="genitourinary" [patient]="patient" />
        </app-expansion-panel>

        <app-expansion-panel title="Psychosocial" value="8">
          <app-psychosocial-info [data]="psychosocial" />
        </app-expansion-panel>

        <app-expansion-panel title="Integumentary" value="9">
          <app-integumentary-info [data]="integumentary" />
        </app-expansion-panel>

        <app-expansion-panel title="Pain Assessment" value="10">
          <app-pain-assessment-info [data]="painAssessment" [patient]="patient" />
        </app-expansion-panel>

        <app-expansion-panel title="Intake and Output" value="11">
          <app-intake-output-info [data]="intakeOutput" />
        </app-expansion-panel>

        <app-expansion-panel title="Provider Notified" value="12">
          <app-provider-notified-info [data]="providerNotified" />
        </app-expansion-panel>

      </p-accordion>
    </p-panel>
  </div>
</div>
}